import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { datadogLogs } from "@datadog/browser-logs";
import { useNotification } from "collections/Notifications";
import { LoginAgainNotification } from "./LoginAgainNotification";
import { LoggerOptions } from "../monitoring/LoggerOptions";

const logger = datadogLogs.createLogger("auth0", LoggerOptions);

export const AuthWatcher = () => {
  const { error } = useAuth0();
  const [addNotification] = useNotification();
  useEffect(() => {
    if (error) {
      logger.error("Authentication Error", error);
      addNotification({
        id: "failed_to_renew_auth",
        message: <LoginAgainNotification />,
        type: "error",
        dismiss: "NOT_DISMISSIBLE"
      });
    }
    // omit t and addNotification from deps, otherwise causes useEffect to call infinitely with no usefulness
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);
  return <></>;
};
